const VERSION = '0.0.14';
export default VERSION;
